
export enum LabelPosition {
  Top,
  Bottom,
}
